import React, { Component } from 'react';
import $ from 'jquery';
import axios from "axios";
import { setCookie, getCookie, login_check, loginUrl, pocketUrl, deleteCookie, checkLogin, addToWordCookie, getCookieCross } from './include/Common';
import Footer from './Footer';
import {Helmet} from 'react-helmet';
//
class TodayQuiz extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,       // JSON 데이터를 저장할 곳
      grid: [],
      keywords: [],
      quizDate: '',
      quizWeek: '',
      selectedWord: null,
      selectChoung: '',
      selectDesc: '',
      popupVisible: false,
      answers: '',
      focusedCells: [],
      solvedPercent: 0,
      remainingCount: 0,
      loading: true,    // 로딩 상태
      error: null,       // 에러 메시지 저장
      loginCheck:false,
    };
  }

  async componentDidMount() {

    const publicUrl = process.env.PUBLIC_URL;
    let corAnswer, corDescript, quizGubn;
    const retLogin = await login_check();
    const params = new URLSearchParams(window.location.search);
    const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=MyQuiz';
    try {



      const response = await axios.get(publicUrl + '/api/getTodayQuiz.php');
      const retData = response.data;

      const quizDate = retData.date;
      const data = response.data;
      /*
      const responseCross = await axios.get(publicUrl + '/api/getCrossWord.php');
      const cwData = responseCross.data;

      //const t_keyword = JSON.parse(cwData.t_keyword); // grid용
      //const keywordJSON = JSON.parse(cwData.keywordJSON); // 전체 키워드 및 설명


      const crossDate = cwData.crossDate;
      */
      this.setState({
        quizDate: retData.date,
        loginCheck:retData.login,
        //quizWeek: cwData.t_year + '' + cwData.t_week,
      });

      quizGubn = retData.gubn;
      let qDate = retData.date.split("-");
      let qDateTxt = qDate[0] + "년 " + Number(qDate[1]) + "월 " + Number(qDate[2]) + "일";
      if (quizGubn == 'm') {
        $("#quizox").hide();
        $("#quizmulti").show();
        $("#quizDatem").text(qDateTxt);
        $("#quizTitlem").text(retData.question);
        $("#quiz1").text(retData.choice1);
        $("#quiz2").text(retData.choice2);
        $("#quiz3").text(retData.choice3);
        $("#quiz4").text(retData.choice4);
      } else {
        $("#quizox").show();
        $("#quizmulti").hide();
        $("#quizDateo").text(qDateTxt);
        $("#quizTitleo").text(retData.question);

      }

      corAnswer = retData.answer;
      corDescript = retData.description;
      const userAnswer = retData.useranswer;
      let pocketTodayQuizCookie = userAnswer;

      if (
        pocketTodayQuizCookie === undefined ||
        pocketTodayQuizCookie === null ||
        pocketTodayQuizCookie === ''
      ) {
        pocketTodayQuizCookie = getCookie('pocketTodayQuiz');
      }

      if (
        pocketTodayQuizCookie !== undefined &&
        pocketTodayQuizCookie !== null &&
        pocketTodayQuizCookie !== ''
      ) {
        const pocketTodayQuizCookieSplit = pocketTodayQuizCookie.split("|");
        const pocketTodayQuiz = pocketTodayQuizCookieSplit[0];
        const pocketTodayQuizGubn = pocketTodayQuizCookieSplit[1];
        if (pocketTodayQuizGubn == quizGubn) {
          const $quiz = $('.section .quiz');
          const $quizAnswer = $quiz.find('.quiz__a');
          let isCorrect = false;
          const publicUrl = process.env.PUBLIC_URL;
          let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + quizDate + '&word=' + pocketTodayQuizCookie + '&mode=quiz';
          axios.get(quizCrossUrl).then(response => {
            if (response.data == 'OK' && pocketTodayQuizCookie) {
              deleteCookie('pocketTodayQuiz');
            }
          });
          // 상태 초기화
          $quiz.removeClass('quiz--pass quiz--fail');
          $quiz.find('.quiz__result').remove();
          $quiz.find('.quiz__result__txt').remove();
          $quiz.find('.quiz__result__btn').remove();
          $quiz.find('.btn').attr('disabled', true);

          $("#quiz" + pocketTodayQuiz).addClass('selected');
          if (corAnswer.toString() == pocketTodayQuiz.toString()) { //정답
            isCorrect = true;
          }

          if (isCorrect) {
            $quiz.addClass('quiz--pass');

            let resultHtml = `
            <div class="quiz__explain">
              <p class="answer">정답 : ${corAnswer}</p>
              <p class="explanation">${corDescript}</p>
            </div>`;
            resultHtml += `<button type="button" class="quiz__explain__toggle"> 해설 보기 </button>`;
            /*
            if (!retLogin) {
              resultHtml += `
              <button class="quiz__result__txt" onclick="window.location.href='`+ loginUrl + '?ref=' + encodeURIComponent(refUrl) + `'">
              로그인하고 퀴즈 내역 남기기 👉
              </button>`;
            } else {
              resultHtml += `
              <a href="/MyQuiz" class="quiz__result__txt">
                퀴즈 내역 보러 가기 👉
              </a>`;
            }
            */
            $quizAnswer.after(resultHtml);
            $quiz.addClass('quiz--pass');
            $('.quiz__explain__toggle').addClass('active');
            $quiz.find('.quiz__explain').addClass('active'); // .show();
            $quiz.find('.quiz__explain__toggle').text('해설 접기');
          } else {
            //// 오답일때
            $quiz.addClass('quiz--fail');
            $quizAnswer.after(`<p class="quiz__result__txt">오답이에요! 다시 풀어보세요🔥</p>`);

            setTimeout(() => {
              //1초 후 노출
              $quiz.find('.date').after(`
            <button type="button" class="quiz__result__btn btn--retry">재도전</button>
            `);
            }, 0);
          }
          //document.getElementById("quiz"+pocketTodayQuiz).click();

          //        const $quiz = $('.section--quiz .quiz');
          //const $quizAnswer = $('.section--quiz .quiz .quiz__a');

        }
      }
      this.setState({
        data: retData,   // JSON 전체를 저장
        loading: false
      });

      if (retLogin) {
        $("#link_viewHistory").show();
      } else {
        $("#link_login").show();
      }
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false
      });
    };

    $('.quiz')
      .find('.btn')
      .on('click', function () {
        // TODO:정답 1번으로 임의 설정

        let isCorrect = false;
        let ansNum;
        if (quizGubn == 'm') {
          ansNum = '' + ($(this).index() + 1);
          if (ansNum == corAnswer)
            isCorrect = true;
        } else if (quizGubn == 'o') {
          ansNum = $(this).val();
          if (ansNum == corAnswer)
            isCorrect = true;
        }
        const quizAnswer = ansNum + '|' + quizGubn;
        setCookie('pocketTodayQuiz', quizAnswer);
        const $quiz = $(this).closest('.quiz');
        const $quizAnswer = $quiz.find('.quiz__a');

        // 상태 초기화
        $quiz.removeClass('quiz--pass quiz--fail');
        $quiz.find('.quiz__result').remove();
        $quiz.find('.quiz__result__txt').remove();
        $quiz.find('.quiz__result__btn').remove();
        $quiz.find('.btn').attr('disabled', true);
 
        $(this).addClass('selected'); 
        const publicUrl = process.env.PUBLIC_URL;
        const quizWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + $('#quizDate').val() + '&word=' + quizAnswer + '&mode=quiz';
        
        //const response = axios.get(quizWordUrl);
        //const retData = response.data;
        axios.get(quizWordUrl).then(response => {
          let retCookie = response.data.split("|");
          if(retCookie[1] == '1'){
            if(Number(retCookie[2]) > 0){
              popupOpen('popup--quizPass');
            }else{
              popupOpen('popup--quizPassNoExp');
            }

            $quiz.addClass('quiz--pass');

            let resultHtml = `
                <div class="quiz__explain">
                  <p class="answer">정답 : ${corAnswer}</p>
                  <p class="explanation">${corDescript}</p>
                </div>`;

            resultHtml += `<button type="button" class="quiz__explain__toggle"> 해설 보기 </button>`;
            /*
            if (!retLogin) {
              resultHtml += `
                  <button class="quiz__result__txt" onclick="window.location.href='`+ loginUrl + '?ref=' + encodeURIComponent(refUrl) + `'">
                    로그인하고 퀴즈 내역 남기기 👉
                  </button>`;
            } else {
              resultHtml += `
                  <a href="/MyQuiz" class="quiz__result__txt">
                    퀴즈 내역 보러 가기 👉
                  </a>`;
            }
            */
            $quizAnswer.after(resultHtml);
            $quiz.addClass('quiz--pass');

            $('.quiz__explain__toggle').addClass('active');
            $quiz.find('.quiz__explain').addClass('active'); // .show();
            $quiz.find('.quiz__explain__toggle').text('해설 접기');

          }else{

            $quiz.addClass('quiz--fail');
            $(this).addClass('fail-ani'); //오답 interaction
            $quizAnswer.after(`
              <p class="quiz__result__txt">오답이에요! 다시 풀어보세요🔥</p>
              `);

            setTimeout(() => {
              //1초 후 노출
              $quiz.find('.date').after(`
                <button type="button" class="quiz__result__btn btn--retry">재도전</button>
                `);
            }, 1000);

          }
        });

      });

    // 재도전 버튼 클릭
    $(document).on('click', '.btn--retry', function () {
      const $quiz = $(this).closest('.quiz');
      $quiz.removeClass('quiz--fail');
      $quiz.find('.quiz__a .btn').removeClass('selected').removeClass('fail-ani').attr('disabled', false);
      $quiz.find('.quiz__result__txt').remove();
      $quiz.find('.quiz__result__btn').remove();
      $quiz.find('.quiz__explain').remove();
      $quiz.find('.quiz__explain__toggle').remove();
    });
    $(document).on('click', '#tab-1', function () {

      if (quizGubn == 'm') {
        $("#quizox").hide();
        $("#quizmulti").show();
      } else {
        $("#quizox").show();
        $("#quizmulti").hide();
      }
    });

    //해설보기 토글
    $(document).on('click', '.quiz__explain__toggle', function () {
      const $btn = $(this);
      const $explain = $btn.prev('.quiz__explain');

      if ($btn.hasClass('active')) {
        $btn.removeClass('active');
        $explain.removeClass('active'); // .hide();
        $btn.text('해설 보기');
      } else {
        $btn.addClass('active');
        $explain.addClass('active'); // .show();
        $btn.text('해설 접기');
      }
    });

    function popupOpen(e) { return $("#" + e).fadeIn().css("display", "flex"), !1 }



    //퀴즈 힌트보기
    $('.hint-btn').on('click', function () {
      $(this).addClass('show');
    });

    //퀴즈팝업 닫기
    function close_quiz_popup() {
      $('.crossword__popup').hide();
      $('.hint-btn').removeClass('show');
      $('body').css('overflow', 'auto');
      return false;
    }
    //  팝업 영역 외 클릭시 닫기
    $('.crossword__popup').on('click', function (e) {
      if (!$(e.target).closest('.popup__wrap').length) {
        close_quiz_popup();
      }
    });

    $('.crossword__popup .close').on('click', function () {
      close_quiz_popup();
    });
  }
  ////
  handelLoginClick = () => {
    const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=MyQuiz';
    window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
  }  
  render() {

    const { data, grid, keywords, selectedWord, loginCheck, selectChoung, selectDesc, popupVisible, loading, error } = this.state;
    const currentUrl = window.location.href;
    const structureData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "오늘의 용어 퀴즈 - 지식포켓",
        "url": currentUrl,
    }
    return (
      <>
        <Helmet>

          <title>오늘의 용어 퀴즈 - 지식포켓</title>
          <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
          <meta name="description" content="매일 달라지는 오늘의 경제/시사 퀴즈! 가볍게 풀면서 지식을 확장해보세요."/>

          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="지식포켓" />
          <meta property="og:title" content="오늘의 용어 퀴즈 - 지식포켓" />
          <meta property="og:description" content="매일 달라지는 오늘의 경제/시사 퀴즈! 가볍게 풀면서 지식을 확장해보세요."/>
          <meta property="og:url" content={currentUrl} />
          <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="ko_KR" />

          <link rel="canonical" href={currentUrl}/>
          <script type="application/ld+json">
          { JSON.stringify(structureData)}
          </script>   
          
        </Helmet>
        <main id="contents" data-page="quiz" className="page--quiz no-search-btn">
          <section className="section">
            <div className="title-bx">
              <h1 className="tit">퀴즈</h1>
            </div>
            <></>
            <div className="tab">
              <ul className="tab-list">
                <li><a href="" id="tab-1" onClick={(e) => e.preventDefault()} className="tab-link active"> 용어 퀴즈 </a></li>
                <li><a href="/TodayCross" id="tab-2" className="tab-link" > 십자말풀이 </a></li>
                <li><a href="/TodaySearch" id="tab-3" className="tab-link"> 미니 게임 </a></li>      
              </ul>
            </div>

            <article className="quiz" data-quiz-id="1" id="quizox" style={{ display: 'none' }}>
              <div className="wrap">
                <p className="date" id="quizDateo"> </p>
                <h3 className="quiz__q" id="quizTitleo"> </h3>
                <div className="quiz__a quiz__a--ox">
                  <button type="button" id="quizO" className="btn btn--o" value='O'> </button>
                  <button type="button" id="quizX" className="btn btn--x" value='X'> </button>
                </div>
              </div>
            </article>
            <article className="quiz" data-quiz-id="1" id="quizmulti" style={{ display: 'none' }}>
              <div className="wrap">
                <p className="date" id="quizDatem">  </p>
                <h3 className="quiz__q" id="quizTitlem"></h3>
                <div className="quiz__a quiz__a--select">
                  <button type="button" className="btn" id="quiz1" value="1"> </button>
                  <button type="button" className="btn" id="quiz2" value="2"> </button>
                  <button type="button" className="btn" id="quiz3" value="3"> </button>
                  <button type="button" className="btn" id="quiz4" value="4"> </button>
                </div>
              </div>
            </article>

          {loginCheck == '1' ? (
            <a href="/MyQuiz" className="quiz__result__txt" id="link_viewHistory" > 퀴즈 내역 보러 가기 👉 </a>
          ) : (
            <button className="quiz__result__txt" id="link_login" onClick={() => this.handelLoginClick()}> 로그인하고 퀴즈 내역 남기기 👉 </button>
          )}
          </section>
          <aside className="crossword__popup">
            <div className="popup__wrap">
              <div className="popup__head">
                <button type="button" className="close"><span className="sr-only">닫기</span></button>
              </div>
              <div className="popup__body">
                <div className="crossword__popup__bx">
                  <p className="title">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="0.5" y="-0.000976562" width="20" height="20" rx="4" fill="#4553E7" />
                      <path d="M7.5 6.57901C7.5 5.27225 8.84251 3.99902 10.5 3.99902C12.1575 3.99902 13.5001 5.05682 13.5001 6.36358C13.5001 6.83443 13.3261 7.27303 13.0246 7.64197C12.1275 8.74104 10.5 9.78851 10.5 11.094" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.4883 15H10.5018" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {selectedWord?.dir == 'V' ? '세로' : '가로'} 퀴즈
                  </p>
                  <div className="scroll-bx">
                    <p className="desc">{selectDesc}</p>
                  </div>
                  <button className="hint-btn">
                    <span className="hint-btn__txt txt">눌러서 힌트 보기 </span>
                    <span className="hint-btn__txt hint"> {selectChoung} </span>
                  </button>
                </div>

                <form id="crossword__popup__input" className="crossword__popup__input">
                  <input type="text" placeholder="정답을 입력하세요" id="inputAnswer" value={this.state.answers} onChange={this.crossWordInputChange} />
                  <button type="submit" title="제출" className="btn-submit" onClick={this.crossWordCheckInput}></button>
                </form>

                <input type='hidden' value={this.state.quizDate} id="quizDate" />
              </div>
            </div>
          </aside>
        </main>
        <Footer />
      </>
    );
  }
}

export default TodayQuiz;    